/*
 * BePositive — Shopify Forms Footer
 * Personalizzazione dello stile del modulo inline.
 * Non modifica i popup Shopify Forms.
 */

(function () {
  'use strict';

  const STYLE_ID = 'bepositive-footer-forms-css';

  const CSS = `

    /* CONTENITORE GENERALE */

    :host {
      display: block !important;
      width: 100% !important;
      background: transparent !important;
      color: #ffffff !important;
    }

    [data-testid="app-router"],
    #form-container-ref,
    section[class*="_inline_"],
    section[class*="_formContainer_"],
    div[class*="_gridItemContent_"] {
      width: 100% !important;
      max-width: none !important;

      padding: 0 !important;
      margin: 0 !important;

      background: transparent !important;
      color: #ffffff !important;

      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    section[class*="_formContainer_"] {
      display: block !important;
    }

    div[class*="_imageLoading_"] {
      display: none !important;
    }


    /* STRUTTURA DEL FORM */

    form[data-testid="form"] {
      display: grid !important;

      grid-template-columns: minmax(0, 1fr) auto !important;

      align-items: end !important;

      gap: 10px 16px !important;

      width: 100% !important;
      max-width: 100% !important;

      margin: 0 !important;
      padding: 0 !important;

      background: transparent !important;
      color: #ffffff !important;

      font-family: HelveticaNeue, Helvetica, Arial, sans-serif !important;
    }


    /* ELEMENTO TECNICO SHOPIFY */

    form[data-testid="form"] > div:has(> shop-lead-capture) {
      grid-column: 1 / -1 !important;
      min-height: 0 !important;
    }


    /* CAMPO EMAIL */

    form[data-testid="form"] > div:has(> [data-testid="field-email"]) {
      grid-column: 1 / -1 !important;
      min-width: 0 !important;
    }


    /* CONTENITORI INPUT */

    form[data-testid="form"] [class*="_formFieldContainer_"] {
      min-width: 0 !important;

      background: transparent !important;

      border: 0 !important;
      border-bottom: 1px solid rgba(255,255,255,.9) !important;

      border-radius: 0 !important;
      box-shadow: none !important;
    }


    /* STILE INPUT */

    form[data-testid="form"] input[class*="_formInputField_"] {
      width: 100% !important;
      min-width: 0 !important;
      min-height: 39px !important;

      padding: 12px 0 5px !important;

      color: #ffffff !important;
      background: transparent !important;

      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;

      font: 400 13px/1.4 HelveticaNeue, Helvetica, Arial, sans-serif !important;
    }

    form[data-testid="form"] input:focus-visible {
      outline: 2px solid #ffffff !important;
      outline-offset: 1px !important;
    }


    /* ETICHETTE CAMPI */

    form[data-testid="form"] label,
    form[data-testid="form"] [class*="_birthdayText_"] {
      color: #ffffff !important;

      font: 400 12px/1.4 HelveticaNeue, Helvetica, Arial, sans-serif !important;
    }


    /* DATA DI NASCITA */

    form[data-testid="form"] [data-testid="date-birthday"] {
      grid-column: 1 !important;
      min-width: 0 !important;

      color: #ffffff !important;
    }

    form[data-testid="form"] [class*="_dateFieldContainer_"] {
      display: flex !important;

      gap: 10px !important;
      width: 100% !important;
    }

    form[data-testid="form"] [class*="_dateFieldContainer_"] > div {
      flex: 1 1 0 !important;
      min-width: 0 !important;
    }


    /* PULSANTE ISCRIVITI */

    form[data-testid="form"] button[data-testid="btn-form-submit"] {
      grid-column: 2 !important;

      justify-self: end !important;

      width: auto !important;
      min-width: 0 !important;
      min-height: 39px !important;

      padding: 7px 0 !important;

      background: transparent !important;
      color: #ffffff !important;

      border: 0 !important;
      border-bottom: 1px solid #ffffff !important;

      border-radius: 0 !important;
      box-shadow: none !important;

      font: 400 13px/1.4 HelveticaNeue, Helvetica, Arial, sans-serif !important;

      text-transform: uppercase !important;

      cursor: pointer !important;
    }

    form[data-testid="form"] button[data-testid="btn-form-submit"]:hover {
      opacity: .75 !important;
    }

    form[data-testid="form"] button[data-testid="btn-form-submit"]:focus-visible {
      outline: 2px solid #ffffff !important;
      outline-offset: 3px !important;
    }


    /* RESPONSIVE MOBILE */

    @media screen and (max-width: 1000px) {

      form[data-testid="form"] {
        grid-template-columns: minmax(0, 1fr) !important;
        gap: 12px !important;
      }

      form[data-testid="form"] > div:has(> [data-testid="field-email"]),
      form[data-testid="form"] [data-testid="date-birthday"],
      form[data-testid="form"] button[data-testid="btn-form-submit"] {
        grid-column: 1 !important;
      }

      form[data-testid="form"] button[data-testid="btn-form-submit"] {
        justify-self: start !important;
      }

    }

    /* ======================================
    LAYOUT NEWSLETTER BEPOSITIVE
    EMAIL + PULSANTE SULLA STESSA RIGA
    DATA DI NASCITA SOTTO
    ====================================== */
    ._formDisclaimer_48bzm_56 p,
    ._formDisclaimer_48bzm_56{
        text-align: justify !important;
    }

    form[data-testid="form"] {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto !important;
    align-items: end !important;
    column-gap: 15px !important;
    row-gap: 8px !important;
    }

    /* EMAIL - PRIMA RIGA A SINISTRA */

    form[data-testid="form"] > div:has(> [data-testid="field-email"]) {
    grid-column: 1 !important;
    grid-row: 1 !important;
    align-self: end !important;
    min-width: 0 !important;
    }

    /* PULSANTE - PRIMA RIGA A DESTRA */

    form[data-testid="form"] > button[data-testid="btn-form-submit"] {
    grid-column: 2 !important;
    grid-row: 1 !important;
    align-self: end !important;
    justify-self: end !important;

    width: auto !important;
    min-width: max-content !important;
    min-height: 38px !important;

    padding: 8px 0 5px !important;

    background: transparent !important;
    color: #ffffff !important;

    border: 0 !important;
    border-bottom: 1px solid #ffffff !important;
    border-radius: 0 !important;
    box-shadow: none !important;

    font-size: 13px !important;
    font-weight: 400 !important;
    text-transform: uppercase !important;
    }

    /* DATA DI NASCITA - SECONDA RIGA */

    form[data-testid="form"] > [data-testid="date-birthday"] {
    grid-column: 1 / -1 !important;
    grid-row: 2 !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    }

    /* TRE CAMPI DATA */

    form[data-testid="form"] [class*="_dateFieldContainer_"] {
    display: grid !important;
    grid-template-columns: 1fr 1fr 2fr !important;
    gap: 12px !important;
    width: 100% !important;
    }

    form[data-testid="form"] [class*="_dateFieldContainer_"] > div {
    min-width: 0 !important;
    }

    /* ETICHETTA DATA DI NASCITA */

    form[data-testid="form"] [class*="_birthdayText_"] {
    margin-bottom: 2px !important;
    color: #ffffff !important;
    font-size: 12px !important;
    }

    /* MOBILE */

    @media screen and (max-width: 600px) {

    form[data-testid="form"] {
        grid-template-columns: minmax(0, 1fr) !important;
        row-gap: 12px !important;
    }

    form[data-testid="form"] > div:has(> [data-testid="field-email"]) {
        grid-column: 1 !important;
        grid-row: 1 !important;
    }

    form[data-testid="form"] > [data-testid="date-birthday"] {
        grid-column: 1 !important;
        grid-row: 2 !important;
    }

    form[data-testid="form"] > button[data-testid="btn-form-submit"] {
        grid-column: 1 !important;
        grid-row: 3 !important;
        justify-self: start !important;
    }
    }

    /* ==========================================
    BEPOSITIVE - MESSAGGIO ISCRIZIONE RIUSCITA
    ========================================== */

    /* CONTENITORE SUCCESSO */

    [data-testid="banner-success"] {
    width: 100% !important;
    max-width: 100% !important;

    background: transparent !important;
    color: #ffffff !important;

    border: none !important;
    box-shadow: none !important;

    padding: 0 !important;
    margin: 0 !important;

    text-align: left !important;

    font-family: HelveticaNeue, Helvetica, Arial, sans-serif !important;
    }

    /* TITOLO */

    [data-testid="banner-success"] h2 {
    color: #ffffff !important;

    font-family: HelveticaNeue, Helvetica, Arial, sans-serif !important;
    font-size: 15px !important;
    font-weight: 500 !important;
    line-height: 1.4 !important;

    margin: 0 0 8px !important;
    padding: 0 !important;
    }

    /* CODICE SCONTO */

    [data-testid="banner-success"] button[class*="_copyToClipboardButton_"] {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center;
        gap: 10px !important;
        width: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: 10px auto !important;
        padding: 0 !important;
        background: transparent !important;
        color: #ffffff !important;
        border: none !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        cursor: pointer !important;
    }

    /* TESTO WELCOME10 */

    [data-testid="banner-success"] [class*="_copyToClipboardText_"] {
    color: #ffffff !important;

    font-family: HelveticaNeue, Helvetica, Arial, sans-serif !important;
    font-size: 20px !important;
    font-weight: 700 !important;
    line-height: 1.3 !important;
    letter-spacing: 0.3px !important;
    }

    /* ICONA COPIA */

    [data-testid="banner-success"] button svg {
    width: 17px !important;
    height: 17px !important;

    color: #ffffff !important;
    fill: #ffffff !important;

    opacity: 1 !important;
    }

    [data-testid="banner-success"] button svg path {
    fill: #ffffff !important;
    }

    /* DESCRIZIONE */

    [data-testid="banner-success"] div[class*="_textBody_"],
    [data-testid="banner-success"] div[class*="_textBody_"] p {
        color: #ffffff !important;
        font-family: HelveticaNeue, Helvetica, Arial, sans-serif !important;
        font-size: 13px !important;
        font-weight: 400 !important;
        line-height: 1.5 !important;
        margin: 8px 0 0 !important;
        padding: 0 !important;
        text-align: center;
    }

    /* TUTTI GLI ALTRI TESTI DEL MESSAGGIO */

    [data-testid="banner-success"] span {
    color: #ffffff !important;
    }

    /* MOBILE */

    @media screen and (max-width: 1000px) {

    [data-testid="banner-success"] {
        text-align: left !important;
    }

    [data-testid="banner-success"] h2 {
        font-size: 14px !important;
    }

    [data-testid="banner-success"] [class*="_copyToClipboardText_"] {
        font-size: 18px !important;
    }

    [data-testid="banner-success"] div[class*="_textBody_"] p {
        font-size: 12px !important;
    }

    }
    
  `;


  /* INIEZIONE CSS NELLA SHADOW ROOT */

  let watchedContainer = null;
  let containerObserver = null;

function applyStyles() {

  const container = document.querySelector('#newsletter');

  if (!container) return;

  container.querySelectorAll('shopify-forms-embed').forEach(function (embed) {

    const root = embed.shadowRoot;

    if (!root || root.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');

    style.id = STYLE_ID;
    style.textContent = CSS;

    root.appendChild(style);

  });

}


  /* CONTROLLO DEL CARICAMENTO */

  function refresh() {

    const container = document.querySelector('#newsletter');

    if (container !== watchedContainer) {

      if (containerObserver) {
        containerObserver.disconnect();
      }

      watchedContainer = container;

      if (container) {

        containerObserver = new MutationObserver(applyStyles);

        containerObserver.observe(container, {
          childList: true,
          subtree: true
        });

      }

    }

    applyStyles();

  }


  /* INIZIALIZZAZIONE */

  function init() {

    refresh();

    document.addEventListener('shopify:section:load', refresh);

    // Shopify Forms viene caricato in modo asincrono.
    // Controlliamo periodicamente per un massimo di 30 secondi.

    let tries = 0;

    const intervalId = setInterval(function () {

      refresh();

      tries += 1;

      if (tries >= 60) {
        clearInterval(intervalId);
      }

    }, 500);

  }


  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });

  } else {

    init();

  }

})();